import { StoreGrades } from 'common/types/entities/store'
import { fetchStoreGrades } from 'common/services/channel'
import { StateKey } from 'common/utils/flipState'

const initialState: StoreGrades = {
  user: null,
  grades: null,
  gradePolicies: null,
  exposureNotice: false,
}

const FETCH = '/store/general/grade/FETCH'

export const fetchGrades = (
  curState: StateKey,
  storeAccountNo: number,
  storeId?: string,
  headers?: any,
) => async dispatch => {
  const result = await fetchStoreGrades(storeAccountNo, storeId, headers)

  dispatch({
    curState,
    payload: result || initialState,
    type: FETCH,
  })
}

const gradesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH: {
      return {
        ...action.payload,
      }
    }
    default:
      return state
  }
}

export default gradesReducer
